// 导入封装好的 axios 实例
import request from '@/utils/request'

//企业表接口
export function officeList(data) {
    return request({
        url: '/sys/office/page',
        method: 'post',
        data
    })
}

// 查询企业
export function queryOffice(id) {
    return request({
        url: `/sys/office/${id}`,
        method: 'get',
    })
}

// 保存市平台信息
export function upsetPlatform(data) {
    return request({
        url: '/sys/office/upsetPlatform',
        method: 'post',
        data
    })
}

// 测试访问
export function testAccess(id) {
    return request({
        url: `/sys/office/accessor?id=${id}`,
        method: 'get',
    })
}

export function saveOrUpdateOffice(data) {
    return request({
        url: '/sys/office',
        method: 'post',
        data
    })
}

export function deleteOffice(id) {
    return request({
        url: `/sys/office/${id}`,
        method: 'delete',
    })
}
